<!--
 * @Author: ZS
 * @Date: 2020-06-09 14:44:54
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-16 16:25:09
 * @Description: file content
-->
<template>
  <div style="background-color:#f1f2f3">
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <v-nav :index="navIndex"></v-nav>
      </div>
      <div class="topQuery roleChoose">
        <div class="mainWidth clearfix">
          <!-- <h2 class="partName pull-right">个人中心/<span>User Center</span></h2> -->
          <ul class="clearfix noselect">
            <li v-for="(item,index) in typeList" :key="index" :class="{active:typeListIndex == index}"
              @click="typeListClick(index,item.pcGuidelineSceneCode)">
              <img :src="item.img">
              <p>{{item.pcGuidelineSceneName}}</p><span>{{item.pcGuidelineSceneContent}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification mainWidth clearfix">
      <div class="left">
        <ul class="tit clearfix noselect">
          <li :class="[{active:tabChangeIndex == 0},{cur:!showDepart}]" @click="tabChange(0)">按主题</li>
          <li :class="{active:tabChangeIndex == 1}" @click="tabChange(1)" v-if="showDepart">按部门</li>
        </ul>
        <div class="content cotnent1 scenes" :class="{active:tabChangeIndex == 0}">
          <ul>
            <li v-for="(item,index) in cjList" :key="index" :class="{active:cjListIndex == index}"
              @click="cjListClick(index,item.pcGuidelineSceneCode)">{{item.pcGuidelineSceneName}}
              <b v-if="item.pcGuidelineParentSceneCode=='9455b50fa1ed4187863aa3beb0b9254e'"
                style="backgroundColor:#e91a22" class="line"></b>
              <b v-if="item.pcGuidelineParentSceneCode=='4e8cfc4a32384b018a0fb5e18f3896a1'"
                style="background-color:#4566e0" class="line"></b>
              <b v-if="item.pcGuidelineParentSceneCode=='e7568f87675746108335d93de7a621c1'"
                style="background-color:#00cc9e" class="line"></b>
              <i class="iconfont icon-youjiantou"></i>
              <!-- <div class="badge">{{item.num}}</div> -->
            </li>
          </ul>
        </div>
        <div class="content cotnent2 departmentList" :class="{active:tabChangeIndex == 1}">
          <ul class="noselect">
            <li v-for="(item,index) in departList" :key="index" class="dept_item_wrap" :class="{active:departListIndex == index}"
              @click="departListClick(index,item.deptCode)">{{item.deptName}}<i class="iconfont icon-youjiantou"></i>
              <!-- <div class="badge">{{item.num}}</div> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="searchCondition">
          <!-- <a href="ywtb_search.html" class="more">
            更多&gt;&gt;
          </a>
          <div class="conditons clearfix">
            <b>事项类型：</b>
            <ul class="clearfix noselect typeOfMatter">
              <li class="active" data-id="">全部</li>
              <li data-id="1">联办审批类</li>
              <li data-id="2">业务办理类</li>
              <li data-id="3">查询服务类</li>
              <li data-id="4">公示公开类</li>
            </ul>
          </div> -->
          <div class="inputSearch" @keyup.enter="searchClick()">
            <el-input placeholder="请输入内容" v-model="parameter.keyWord">
              <el-button slot="append" class="searchBtn" @click="searchClick()">查询</el-button>
            </el-input>
          </div>
        </div>
        <ul class="ywtbListsContent clearfix noselect">
          <li class="searchShow" v-for="(item,index) in searchContentList" :key="index">
            <img :src="item.portalPcHandlingGuidelineImg">
            <div
              class="collection_wrap"
              v-if="$store.state.isLogin"
              :class="{
                active: item.portalPcHandlingGuidelineCollection === 1
              }"
              @click="publicJs.collection(item)"
            >
              <i
                class="iconfont icon-sc"
                :class="{active: item.portalPcHandlingGuidelineCollection === 1}"
              ></i><span v-if="item.portalPcHandlingGuidelineCollection === 1">&nbsp;取消收藏</span><span v-else>&nbsp;&nbsp;收藏</span>
            </div>
            <h3 :title="item.portalPcHandlingGuidelineName">{{item.portalPcHandlingGuidelineName}}</h3>
            <!-- 部门名称 -->
            <div class="dept_name_wrap">{{item.department}}</div>
            <!-- 评分 -->
            <div class="score_wrap">
              <el-rate
                :value="item.satisfaction || 0"
                disabled
                :show-score="false"
                text-color="#ff9900"
              >
              </el-rate>
            </div>
            <a
              v-if="String(item.portalPcHandlingGuideline) === '1'"
              href="javascript:;" 
              class="btn btn-primary znBtn"
              @click="viewDetail(item.portalPcHandlingGuidelineId,item.portalPcHandlingGuidelineCode)">办事指南</a>
            <a
              v-if="[null, undefined, ''].indexOf(item.portalPcHandlingGuidelineUrl) === -1 && item.ljbl === 1"
              :href="item.portalPcHandlingGuidelineUrl"
              class="btn btn-primary blBtn"
              @click="globalAddVisit(item.portalPcHandlingGuidelineCode)"
              target="_blank">立即办理</a>
            <!-- <i class="iconfont icon-sc" :class="[{active:item.portalPcHandlingGuidelineCollection == 1}]"
              v-if="$store.state.isLogin" @click="publicJs.collection(item)"></i> -->
          </li>
        </ul>
        <div class="noData" v-if="noYy">
          <img src="../../assets/images/yyqs.png" alt="">
          <p>暂无数据</p>
        </div>
        <div class="block" style="text-align:center;padding:10px 0" v-show="fyTotalNum != 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="parameter.pageNum" :page-sizes="[15, 30, 45, 60]" :page-size="parameter.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total=fyTotalNum>
          </el-pagination>
        </div>
        <!-- <div class="nullData bszn_null" style="margin-top: 30px;">
          <img src="./ywtb/images/null.png" alt="">
          <p>暂无数据</p>
        </div> -->
      </div>
    </div>
    <div class="clearfix mainWidth">
    </div>
    <v-footer :hasInfo=0></v-footer>
    <v-toolBar></v-toolBar>
  </div>
</template>

<script>
  import Footer from '../common/Footer'
  import Header from '../common/Header'
  import TopNav from '../common/TopNav'
  import ToolBar from '../common/ToolBar'
  import qs from 'qs';
  export default {
    components: {
      'v-footer': Footer,
      'v-header': Header,
      'v-nav': TopNav,
      'v-toolBar': ToolBar
    },
    data() {
      return {
        navIndex: 1,
        typeListIndex: 0,
        currentPage3: 5,
        showDepart: true, //是否显示按部门
        typeList: '',
        tabChangeIndex: 0, //场景主题切换
        cjList: '', //场景列表数据
        cjListIndex: 0,
        departList: '', //部门数据
        ztParam: '', //主题列表的参数
        departParam: '', //部门列表的参数
        departListIndex: '',
        parameter: {
          deptCode: '',
          keyWord: '',
          flag: 1,
          pageNum: 1,
          pageSize: 15,
          // pcGuidelineSceneCode: 'sceneCode',
          pcGuidelineSceneCode: '',
        },
        searchContentList: '', //检索内容,
        fyTotalNum: 0,
        noYy: false
      }
    },
    mounted() {
      this.parameter.keyWord = localStorage.getItem('searchVal');
      localStorage.setItem('searchVal', '')
      let cCode = localStorage.getItem('pcGuidelineSceneCode');
      let pCode = localStorage.getItem('pcGuidelineSceneParentCode');
      this.ztParam = pCode
      // 加入null判断，当第一次进入该页面时处理逻辑
      if (cCode != '' && cCode !== null) {
        this.parameter.flag = 0
        this.parameter.pcGuidelineSceneCode = cCode
        this.showDepart = false
      }
      if (this.showDepart) {
        Promise.all([
          this.findDepartmentHandlingGuidelineNumList()
        ]).then(() => {
          // 判断是部门或者主题
          const deptCode = this.$route.query.code;
          if (deptCode !== undefined) {
            this.tabChangeIndex = 1;
          } else {
            return;
          }
          // 处理数据
          let index = this.departList.findIndex((item) => {
            return item.deptCode === deptCode
          });
          if (index === -1) {
            index === 0;
          }
          this.departListClick(index, deptCode);
          this.$nextTick(() => {
            document.querySelector(".dept_item_wrap.active").scrollIntoView();
          });
        });
      }
      localStorage.setItem('pcGuidelineSceneCode', '')
      localStorage.setItem('searchOrder', '')
      localStorage.setItem('pcGuidelineSceneParentCode', '')
      this.findPortalPcGuidelineTypeList();
      this.findDepartmentSceneNumList();
      // this.findDepartmentHandlingGuidelineNumList()
      this.findHandlingGuidelineList();
      console.log(this.parameter.pcGuidelineSceneCode)
    },
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.parameter.pageSize = val
        this.findHandlingGuidelineList()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.parameter.pageNum = val
        // console.log(this.parameter.pageNum);
        this.findHandlingGuidelineList()
      },
      // 获取顶部服务类型
      findPortalPcGuidelineTypeList() {
        this.ywtbRequest('/portal-ywtb/web/guidelineScene/findPcGuidelineSceneList').then((res) => {
          let data = res.dataList
          let TempData = {
            count: null,
            pcGuidelineSceneContent: "All",
            pcGuidelineSceneCode: '',
            pcGuidelineSceneName: "全部服务"
          }
          data.unshift(TempData)
          for (let i = 0; i < data.length; i++) {
            data[i].img = require('../../assets/images/serviceType' + i + '.png')
            if (data[i].pcGuidelineSceneCode == this.ztParam) {
              this.typeListIndex = i
            }
          }
          this.typeList = data
        })
      },
      // 获取场景主题列表
      findDepartmentSceneNumList() {
        let sendData = qs.stringify({
          pcGuidelineSceneCode: this.ztParam,
          flag: 1
        })
        this.ywtbRequest('/portal-ywtb/web/portalPcGuidelineSceneGuideline/findDepartmentSceneNumList', sendData)
          .then((res) => {
            // let totalNum = 0
            let data = res.dataList
            for (let index = 0; index < data.length; index++) {
              // totalNum += data[index].num
              if (data[index].pcGuidelineSceneCode == this.parameter.pcGuidelineSceneCode) {
                this.cjListIndex = index 
              }
            }
            // let TempData = {
            //   "pcGuidelineSceneName": "全部",
            //   "num": totalNum,
            //   "pcGuidelineSceneCode": "sceneCode"
            // }
            // data.unshift(TempData)
            // console.log(data)
            this.cjList = data
            // console.log(this.cjList)
          })
      },
      //获取部门列表
      findDepartmentHandlingGuidelineNumList() {
        let sendData = qs.stringify({
          pcGuidelineSceneCode: this.departParam
        })
        return new Promise((resolve, reject) => {
          this.ywtbRequest('portal-ywtb/web/portalPcGuidelineDepartmentGuideline/findDepartmentHandlingGuidelineNumList',
            sendData)
          .then((res) => {
            // let totalNum = 0
            let data = res.dataList
            // for (let index = 0; index < data.length; index++) {
            //   totalNum += data[index].num
            // }
            // let TempData = {
            //   "deptName": "全部",
            //   "num": totalNum,
            //   "deptCode": "deptCode"
            // }
            // data.unshift(TempData)
            this.departList = data;
            // 请求完成
            resolve(data);
          }).catch((e) => {
            reject(e);
          })
        });
      },
      //场景主题切换
      tabChange(idx) {
        // 切换url
        this.$router.replace({
          path: this.$route.path
        });
        this.tabChangeIndex = idx
        this.parameter.flag = 1
        if (idx === 0) {
          this.departListIndex = 0
          this.parameter.deptCode = ''
          // this.parameter.pcGuidelineSceneCode = 'sceneCode'
          this.parameter.pcGuidelineSceneCode = ''
        } else if (idx === 1) {
          this.cjListIndex = 0
          // this.parameter.deptCode = 'deptCode'
          this.parameter.deptCode = ''
          this.parameter.pcGuidelineSceneCode = ''
        }
        this.handleCurrentChange(1);
      },
      typeListClick(index, code) {
        this.typeListIndex = index;
        // 重置下方选中项
        this.cjListIndex = 0;
        this.departListIndex = 0;
        this.parameter.pcGuidelineSceneCode = code
        if (index === 0) {
          this.ztParam = ''
          this.departParam = '';
        } else {
          this.ztParam = code
          this.departParam = code
        }
        this.parameter.flag = 1
        this.findDepartmentSceneNumList()
        this.findDepartmentHandlingGuidelineNumList()
        this.handleCurrentChange(1);
      },
      // 场景主题列表点击筛选
      cjListClick(index, code) {
        this.cjListIndex = index
        this.parameter.pcGuidelineSceneCode = code || this.typeList[this.typeListIndex].pcGuidelineSceneCode;
        // 区分全部和每个主题
        this.parameter.flag = code ? 0 : 1;
        // 设置切换时，deptCode为空
        if (this.tabChangeIndex === 1) {
          this.parameter.deptCode = "";
        }
        this.handleCurrentChange(1);
      },
      // 部门列表点击筛选
      departListClick(index, code) {
        this.departListIndex = index
        this.parameter.deptCode = code
        this.parameter.flag = 1
        this.handleCurrentChange(1);
        // 更改当前query的code
        if (this.$route.fullPath === `${this.$route.path}?code=${code}`) {
          return;
        }
        this.$router.replace({
          path: this.$route.path,
          query: {
            code
          }
        });
      },
      //获取多条件检索内容数据
      findHandlingGuidelineList() {
        let obj = {
          ...this.parameter
        };
        if (this.tabChangeIndex == 1) {
          // 部门的
          obj["pcGuidelineSceneCode"] = this.ztParam;
        } else {
          // 主题的，如果当前obj没有主题code，则用上面的
          if (!obj["pcGuidelineSceneCode"]) {
            obj["pcGuidelineSceneCode"] = this.ztParam;
          }
        }
        let sendData = qs.stringify(obj);
        this.ywtbRequest('portal-ywtb/web/guideline/findHandlingGuidelineList', sendData).then(res => {
          this.fyTotalNum = res.data.toteCount
          let data = res.dataList
          if (data.length == 0) {
            this.noYy = true
          } else if (data.length > 0) {
            this.noYy = false
          }
          for (let i = 0; i < data.length; i++) {
            // data[i].portalPcHandlingGuidelineImg =
            //   '/portal-ywtb/public/getImg?path=' + encodeURI(data[i].portalPcHandlingGuidelineImg)
            data[i].portalPcHandlingGuidelineImg = `/portal-ywtb/${data[i].portalPcHandlingGuidelineImg}`;
          }
          this.searchContentList = data
        })
      },
      //点击搜索按钮
      searchClick() {
        this.handleCurrentChange(1);
      },
      viewDetail(id, code) {
        this.$router.push({
          path: '/guide',
          query: {
            code
          }
        })
      }

    }
  }

</script>

<style lang="scss" scoped>
  .topQuery {
    /* background: url(../../../static/images/userBg.png) no-repeat 0px 0px; */
    height: 276px;
    /* background-size: 100% 160%; */
    padding: 0;
  }

  .topQuery>div {
    position: relative;
  }

  .pageName {
    position: absolute;
    top: -43px;
    right: -10px;
    width: 113px;
    height: 33px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, .46);
    border-radius: 17px;
  }

  .roleChoose ul {
    display: inline-block;
    margin-top: 93px;
    padding: 0px 96px;
  }

  .roleChoose ul li {
    width: 232px;
    height: 95px;
    background: rgba(255, 255, 255, 0.5);
    float: left;
    margin-right: 20px;
    padding-left: 100px;
    text-align: left;
    position: relative;
    cursor: pointer;
  }

  .roleChoose ul li:nth-child(5) {
    margin-right: 0px;
  }

  .roleChoose ul li p {
    font-size: 16px;
    color: #3B4559;
    margin-top: 19px;
    line-height: 30px;
  }

  .roleChoose ul li.active p {
    color: #fff;
  }

  .roleChoose ul li span {
    color: #57647D;
    font-size: 14px;
  }

  .roleChoose ul li.active span {
    color: #fff;
  }

  .roleChoose ul li img {
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    top: 17px;
    left: 25px;
  }

  .roleChoose ul li.active {
    background: rgba(71, 114, 189, 1);
  }

  /* 内容 */
  .classification {
    margin-top: 15px;
    margin-bottom: 30px;
    background-color: #fff;
  }

  .classification .left {
    float: left;
    width: 200px;
  }

  .classification .left .content ul {
    height: 680px;
    overflow: auto;
    padding: 0 12px;
  }

  .classification .right {
    float: left;
    height: 100%;
    width: 1000px;
    min-height: 770px;
    border-left: 1px solid #E4E4E4;
  }

  .classification .left .tit {
    width: 100%;
  }

  .classification .left .tit li {
    float: left;
    width: 50%;
    cursor: pointer;
    line-height: 48px;
    color: #56585C;
    text-align: center;
    background: rgba(247, 247, 247, 1);
  }

  .classification .left .tit li.cur {
    width: 100%;
  }

  .classification .left .tit li.active {
    background-color: #1B3E83;
    color: #fff;
  }

  .classification .left .content {
    display: none;
    padding: 20px 0px;
  }

  .classification .left .content.active {
    display: block;
  }

  .classification .left .content>ul>li {
    color: #56585C;
    line-height: 50px;
    border-bottom: 1px solid #E4E4E4;
    padding-left: 7px;
    cursor: pointer;
    position: relative;
    padding-right: 33px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .classification .left .content>ul>li .iconfont {
    position: absolute;
    right: 0px;
    color: #A4A7AD;
    top: 0px;
  }

  .classification .left .content>ul>li:last-child {
    border-bottom: 1px solid #fff;
  }

  .classification .left .content>ul>li.active {
    color: #56585C;
    font-weight: 700;
    color: #1B3E83;
    ;
  }

  .classification .left .content>ul>li.active .iconfont {
    color: #56585C;
    font-weight: 700;
    color: #1B3E83;
  }

  .inputSearch .searchBtn {
    background-color: #1B3E83;
    color: #fff;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border: 1px solid #1B3E83;
  }

  .searchCondition {
    padding: 20px 23px;
    position: relative;
    border-bottom: 1px solid #eaeaea;
  }

  .searchCondition .form-control {
    border: 1px solid #4772BD
  }

  .searchCondition .btn-default:hover {
    border-color: #1B3E83;
  }

  .searchCondition .inputSearch {
    width: 355px;
  }

  .ywtbListsContent {
    padding: 10px 10px;
  }

  .ywtbListsContent li {
    float: left;
    width: 316px;
    // height: 110px;
    height: 132px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    position: relative;
    padding: 17px 18px 0 96px;
    margin: 10px 5px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.05);
  }

  .ywtbListsContent li .iconfont {
    /* position: absolute; */
    /* right: 10px; */
    /* top: 6px; */
    color: #c5c5c5;
    /* display: none; */
    cursor: pointer;
  }

  .ywtbListsContent li:hover .iconfont {
    // display: block;
  }

  .ywtbListsContent li .iconfont.active {
    color: #fa1818;
  }

  .ywtbListsContent li:hover {
    border: 1px solid rgba(233, 26, 34, 1);
    box-shadow: 0px 0.25rem 1.25rem rgba(233, 26, 34, 0.2);
  }

  .ywtbListsContent li>img {
    width: 60px;
    height: 60px;
    position: absolute;
    // top: 23px;
    top: 20px;
    left: 18px;
  }

  .ywtbListsContent li>h3 {
    font-size: 16px;
    font-weight: 700;
    color: #4B4F58;
    width: 216px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ywtbListsContent li>p {
    margin-top: 10px;
    width: 216px;
    height: 40px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #95A1B7;
  }

  .ywtbListsContent li>a {
    width: 86px;
    padding: 4px 12px;
    border: 1px solid rgba(71, 114, 189, 1);
    border-radius: 4px;
    // margin-top: 20px;
    margin-top: 4px;
    margin-left: 3px;
  }

  .ywtbListsContent li .znBtn {
    color: #4772BD;
    background-color: #fff;
  }

  .ywtbListsContent li .blBtn {
    color: #fff;
    background-color: #4772BD;
  }

  .classify-list li.active a {
    border: 1px solid;
    color: #fff;
  }

  .classify-list li.active a {
    border-color: #4772BD;
    background-color: #4772BD;
  }

  .sub-search-box {
    height: auto;
    width: 1240px;
    margin-top: 12px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px 12px;
    background-color: #fff;
    overflow: hidden;
  }

  .badge {
    position: absolute;
    top: 14px;
    left: 130px;
    min-width: 20px;
    text-align: center;
    color: #fff;
    background-color: #4F73BF;
    border-radius: 10px;
    line-height: 20px;
    padding: 0 4px;
    font-size: 12px;
  }

  .classification .left .content>ul>li b {
    display: inline-block;
    width: 3px;
    height: 20px;
    position: absolute;
    top: 15px;
    left: 0;
  }

  .noData {
    text-align: center;
  }

.collection_wrap {
  position: absolute;
  left: 0;
  bottom: 14px;
  // display: none;
  left: 20px;
  font-size: 12px;
  cursor: pointer;
  .iconfont {
    font-size: 14px;
    display: inline-block;
    transform: translateY(1px);
  }
  span {
    color: #aaa;
  }
  &.active {
    .iconfont, span {
      color: rgb(247, 186, 42) !important;
      // color: #fa1818;
    }
  }
}
.dept_name_wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.score_wrap /deep/ {
  .el-rate {
    i {
      font-size: 14px;
    }
  }
}
.ywtbListsContent li:hover .collection_wrap {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Search.vue